import { Link } from 'react-router-dom';
import { ChevronDown, LogOut, User } from 'lucide-react';
import { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

export function Header() {
  const { user, isAuthenticated, signIn, signOut } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="h-16 bg-navy-dark border-b border-wolf-700/50">
      <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between">
        <Link
          to={isAuthenticated ? '/dashboard' : '/'}
          className="flex items-center gap-3 text-xl font-bold text-wolf-100 hover:text-action transition-colors duration-300"
        >
          <img src="/catalyst-image.png" alt="Catalyst" className="h-10 w-10" />
          <span className="text-action">Catalyst</span>
        </Link>

        <nav className="flex items-center gap-6">
          <Link
            to="/framework"
            className="text-sm text-wolf-300 hover:text-wolf-100 transition-colors duration-300"
          >
            Framework
          </Link>

          {isAuthenticated && user ? (
            <div className="relative" ref={menuRef}>
              <button
                onClick={() => setMenuOpen(!menuOpen)}
                className="flex items-center gap-2 text-sm text-wolf-300 hover:text-wolf-100 transition-colors duration-300"
              >
                {user.name || user.email}
                <ChevronDown className="w-4 h-4" />
              </button>

              {menuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-wolf-900/95 border border-wolf-700/50 shadow-lg">
                  <div className="px-4 py-3 border-b border-wolf-700/50">
                    <p className="text-xs text-wolf-500">Signed in as</p>
                    <p className="text-sm text-wolf-100 truncate">{user.name || user.email}</p>
                  </div>
                  <Link
                    to="/profile"
                    onClick={() => setMenuOpen(false)}
                    className="w-full px-4 py-3 flex items-center gap-2 text-sm text-wolf-300 hover:text-wolf-100 hover:bg-wolf-700/30 transition-colors duration-300"
                  >
                    <User className="w-4 h-4" />
                    Profile
                  </Link>
                  <button
                    onClick={() => {
                      setMenuOpen(false);
                      signOut();
                    }}
                    className="w-full px-4 py-3 flex items-center gap-2 text-sm text-wolf-300 hover:text-wolf-100 hover:bg-wolf-700/30 transition-colors duration-300"
                  >
                    <LogOut className="w-4 h-4" />
                    Sign out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button
              onClick={signIn}
              className="text-sm text-wolf-300 hover:text-wolf-100 transition-colors duration-300"
            >
              Sign in
            </button>
          )}
        </nav>
      </div>
    </header>
  );
}
